import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router'
import Helmet from 'react-helmet';

import * as categoryApi from '../../api/category-api';
import * as baseApi from '../../api/base-api';

import store from '../../../store';
import { propsRecievedCategoryList } from '../../actions/base-actions';
import { propsRecievedOptions } from '../../actions/options-actions';

import EasyTransition from 'react-easy-transition'

import ProjectList from '../../components/projectList/index'

import './baseLayout.css';


class baseLayout extends Component {

  constructor(props) {
    super()
    this.props = props
  }

  componentDidMount() {
    categoryApi.getCategoriesList()
    baseApi.getOptions()
  }

  componentWillReceiveProps(nextProps){
    store.dispatch(propsRecievedCategoryList(true));
  }

  render() {
    if(this.props.propsRecieved === true) {
      return (
        <div className="body-wrapper">
          <Helmet
          htmlAttributes={{lang: "en", amp: undefined}} 
          title={"Stylist"}
          titleTemplate="KK OBI - %s"
          titleAttributes={{itemprop: "name", lang: "en"}}
          meta={[
            {name: "description", content: "KK OBI - Stylist"},
            {property: "og:title", content: "KK OBI - Stylist"},
            {property: "og:image", content: "http://s3-eu-west-1.amazonaws.com/iamdeaneyelid/wp-content/uploads/2016/11/22215224/573545-800w.jpg"}
          ]}/>
          <div className="sidebar">
            <div className="sidebar-wrapper">
              <Link to={'/'} className="title">KK OBI</Link>
              <ProjectList projects={this.props.projects}/>
            </div>
          </div>  
          <main className="main">
            <EasyTransition
            path={location.pathname}
            initialStyle={{opacity: 0}}
            transition="opacity 0.25s ease-in"
            finalStyle={{opacity: 1}}
            >
              {this.props.children}
           </EasyTransition>   
          </main>
          <footer className="footer">
            <a href={`mailto:${this.props.options.email}`} className="email-icon social-icon">Email</a>
            <a href={`http://www.instagram.com/${this.props.options.instagram}`} target="_blank" className="instagram-icon social-icon">Instagram</a>
          </footer>
        </div>
      )
    }else{
      return(null)  
    }
  }
}

const mapStateToProps = (store) => {
  return {
    options: store.optionsState.optionsData,
    projects: store.baseState.categoryListData,
    propsRecieved: store.baseState.propsRecieved,
  };
};

export default connect(mapStateToProps)(baseLayout);


/** WEBPACK FOOTER **
 ** ./src/js/layouts/baseLayout/baseLayout.js
 **/